const enrichmentOperations = [
    'ADDRESS_LOOSEMATCHKEY',
    'ADDRESS_MATCHKEY',
    'ADDRESS_NORMALIZE',
    'ADDRESS_CITY',
    'ADDRESS_STATE',
    'ADDRESS_STREETNAME',
    'ADDRESS_HOUSENUM',
    'ADDRESS_STREETSUFFIX',
    'ADDRESS_UNITNUM',
    'ADDRESS_UNITTYPE',
    'ADDRESS_ZIP',
    'NAME_NORMALIZE',
    'NAME_MATCHKEY',
    'PHONE_NORMALIZE',
];

const enrichmentExpressions = {
    ADDRESS_LOOSEMATCHKEY: '(normalize_us_address($placeholder)).loose_match_key',
    ADDRESS_MATCHKEY: '(normalize_us_address($placeholder)).match_key',
    ADDRESS_NORMALIZE: '(normalize_us_address($placeholder)).normalized',
    ADDRESS_CITY: '(normalize_us_address($placeholder)).city',
    ADDRESS_STATE: '(normalize_us_address($placeholder)).state',
    ADDRESS_STREETNAME: '(normalize_us_address($placeholder)).street_name',
    ADDRESS_HOUSENUM: '(normalize_us_address($placeholder)).house_number',
    ADDRESS_STREETSUFFIX: '(normalize_us_address($placeholder)).street_suffix',
    ADDRESS_UNITNUM: '(normalize_us_address($placeholder)).unit_number',
    ADDRESS_UNITTYPE: '(normalize_us_address($placeholder)).unit_type',
    ADDRESS_ZIP: '(normalize_us_address($placeholder)).zip5',
    NAME_NORMALIZE: 'normalize_name($placeholder)',
    NAME_MATCHKEY: 'normalize_name_tokens($placeholder)',
    PHONE_NORMALIZE: 'normalize_phone($placeholder)',
};

export {
    enrichmentOperations,
    enrichmentExpressions,
};
